import { computed } from "vue";
import { useStore } from "vuex";
import {
  COMPONENT_TYPE,
  DAT_ROUTE_NAMES,
  NAMESPACE,
  SPACE_VIEW,
} from "@modules/attempt/service/attempt.constant";

export function useAttemptSpace() {
  const store = useStore();

  const currentUserId = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/currentUserId`]);
  const previousUserId = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/previousUserId`]);
  const currentSpace = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/currentSpace`]);
  const previousSpace = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/previousSpace`]);
  const currentComponentId = computed(
    () => store.getters[`${NAMESPACE.ATTEMPT}/currentComponentId`],
  );
  const currentPageId = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/currentPageId`]);
  const isMonitoringPage = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/isMonitoringPage`]);
  const currentRouteName = computed(() => store.getters[`${NAMESPACE.APP}/currentRouteName`]);

  const userId = computed(() => store.getters[`${NAMESPACE.AUTH}/userId`]);
  const getComponent = (id: string) => store.getters[`${NAMESPACE.RESOURCE}/getComponent`](id);
  const isActivityTeamResponse = (pageId: string) =>
    store.getters[`${NAMESPACE.RESOURCE}/isActivityTeamResponse`](pageId);

  const isMySpace = computed(
    () =>
      currentSpace.value === SPACE_VIEW.INDIVIDUAL &&
      userId.value === currentUserId.value.toString(),
  );
  const showSpaceBar = computed(
    () =>
      !isMySpace.value &&
      !(
        isCommonSpace.value &&
        currentComponent.value &&
        currentComponent.value.type === COMPONENT_TYPE.TOPIC
      ) &&
      !isInDataAssistantSpace.value &&
      !(isConversationRoom.value && !isVisitingView.value),
  );

  const isInDataAssistantSpace = computed(() => {
    return DAT_ROUTE_NAMES.includes(currentRouteName.value);
  });
  const currentComponent = computed(() => getComponent(currentComponentId.value));
  const isMonitoringSpace = computed(() => currentSpace.value === SPACE_VIEW.MONITORING);
  const isVisitingView = computed(
    () =>
      (currentSpace.value === SPACE_VIEW.INDIVIDUAL || isConversationRoom.value) &&
      userId.value !== currentUserId.value.toString(),
  );
  const isCommonSpace = computed(() => currentSpace.value === SPACE_VIEW.COMMON);
  const isConversationRoom = computed(() => currentSpace.value === SPACE_VIEW.CONVERSATION_ROOM);
  const isAggregateAttemptSpace = computed(
    () => currentSpace.value === SPACE_VIEW.AGGREGATE_ATTEMPT,
  );
  const isAggregateQuizAttemptSpace = computed(
    () => currentSpace.value === SPACE_VIEW.AGGREGATE_QUIZ_ATTEMPT,
  );
  const isAbilitySnapshotSpace = computed(() => currentSpace.value === SPACE_VIEW.ABILITY_SNAPSHOT);
  const isActivitySpace = computed(() => currentSpace.value === SPACE_VIEW.ACTIVITY_PAGE);
  const isCommonSpaceView = computed(
    () =>
      isCommonSpace.value ||
      isConversationRoom.value ||
      isAggregateAttemptSpace.value ||
      isAggregateQuizAttemptSpace.value ||
      isAbilitySnapshotSpace.value,
  );
  const isFromMonitoringSpace = computed(() => previousSpace.value === SPACE_VIEW.MONITORING);
  const isTeamActivity = computed(() => isActivityTeamResponse(currentPageId.value));

  return {
    currentUserId,
    previousUserId,
    currentSpace,
    previousSpace,
    currentComponentId,
    currentPageId,
    isMonitoringPage,
    userId,
    getComponent,
    isActivityTeamResponse,
    showSpaceBar,
    isMySpace,
    isMonitoringSpace,
    isVisitingView,
    isCommonSpaceView,
    isCommonSpace,
    isConversationRoom,
    isAggregateAttemptSpace,
    isAggregateQuizAttemptSpace,
    isAbilitySnapshotSpace,
    isActivitySpace,
    isFromMonitoringSpace,
    isTeamActivity,
    isInDataAssistantSpace,
  };
}
